import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { trackCategoriesResultsScreenView } from "@faire/web-api--source/events/categories/view/resultsScreen";
import { useEffect } from "react";

export const useRecordCategoryPageImpression = () => {
  const navigationPath = useCurrentNavigationPath();

  useEffect(() => {
    trackCategoriesResultsScreenView(navigationPath);
  }, [navigationPath]);
};
